'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icons = require('./icons');

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var mimeTypes = {
  'image/gif': _icons2.default.image,
  'image/jpeg': _icons2.default.image,
  'image/png': _icons2.default.image,
  'application/pdf': _icons2.default.pdf,
  'application/msword': _icons2.default.word,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': _icons2.default.word,
  'application/mspowerpoint': _icons2.default.powerpoint,
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': _icons2.default.powerpoint,
  'application/msexcel': _icons2.default.excel,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': _icons2.default.excel,
  'text/csv': _icons2.default.csv,
  'audio/aac': _icons2.default.audio,
  'audio/wav': _icons2.default.audio,
  'audio/mpeg': _icons2.default.audio,
  'audio/mp4': _icons2.default.audio,
  'audio/ogg': _icons2.default.audio,
  'video/x-msvideo': _icons2.default.video,
  'video/mpeg': _icons2.default.video,
  'video/mp4': _icons2.default.video,
  'video/ogg': _icons2.default.video,
  'video/quicktime': _icons2.default.video,
  'video/webm': _icons2.default.video,
  'application/gzip': _icons2.default.archive,
  'application/zip': _icons2.default.archive,
  'text/css': _icons2.default.code,
  'text/html': _icons2.default.code,
  'text/javascript': _icons2.default.code,
  'application/javascript': _icons2.default.code,
  'text/plain': _icons2.default.text,
  'text/richtext': _icons2.default.text,
  'text/rtf': _icons2.default.text
};
exports.default = mimeTypes;